export const WORKSPACE_SESSION_CHANGED_EVENT = 'workspace-session-changed';

export const notifyWorkspaceSessionChanged = (): void => {
  window.dispatchEvent(new Event(WORKSPACE_SESSION_CHANGED_EVENT));
};
